"use client"

import { motion } from "framer-motion"
import { Clock, Award, Gem } from "lucide-react"
import { Card, CardContent } from "./ui/card"

const promises = [
  {
    icon: <Clock className="h-10 w-10 text-amber-600" />,
    title: "Designed to Last a Lifetime",
    description: "Our pieces are crafted with longevity in mind, using techniques that have stood the test of time.",
  },
  {
    icon: <Award className="h-10 w-10 text-amber-600" />,
    title: "Created by Craftsmen, Not Factories",
    description: "Every piece tells the story of the hands that made it, carrying the soul of true craftsmanship.",
  },
  {
    icon: <Gem className="h-10 w-10 text-amber-600" />,
    title: "Curated, Not Mass Produced",
    description: "We believe in quality over quantity, selecting only the finest materials and designs.",
  },
]

export default function PromiseSection() {
  return (
    <section className="mobile-section-padding relative isolate bg-white py-12 sm:py-16 md:py-20 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6">
        <motion.h2
          className="mobile-heading-xl mobile-element-spacing mb-8 sm:mb-12 md:mb-16 text-center font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-neutral-800 leading-tight"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Why We Exist
        </motion.h2>

        <div className="promise-grid-mobile grid grid-cols-1 gap-6 sm:gap-8 md:gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {promises.map((promise, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: index * 0.15, type: "spring" }}
              whileHover={{ scale: 1.02 }}
              className="h-full"
            >
              <Card className="mobile-card bg-white shadow-xl border border-stone-200 hover:shadow-[0_0_15px_rgba(218,112,214,1)] hover:border-[#DA70D6]/30 transition-all duration-300 rounded-xl sm:rounded-2xl h-full">
                <CardContent className="promise-card-mobile flex flex-col items-center px-4 sm:px-6 pt-4 sm:pt-5 pb-6 sm:pb-8 text-center h-full">
                  <div className="mb-4 sm:mb-6">{promise.icon}</div>
                  <h3 className="mb-3 sm:mb-4 font-serif text-lg sm:text-xl font-semibold text-neutral-800 px-1 sm:px-2 leading-tight">
                    {promise.title}
                  </h3>
                  <p className="text-sm sm:text-base text-neutral-600 leading-relaxed px-1 flex-grow">
                    {promise.description}
                  </p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
} 